import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'

import SectionPreHeader from './section/SectionPreHeader'

const TestimonialList = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  @media (min-width: 800px) {
    flex-direction: row;
  }

`

const TestimonialCardContainer = styled.div`
  flex: 1;
  text-align: center;
  padding: 1rem;
  box-sizing: border-box;
  background-color: white;
  margin-bottom: 3rem;
  box-shadow: 0.5rem 0.5rem 0px #18aa7a;
  border: 2px solid #18aa7a;
  position: relative;

  a {
    font-size: .8rem;
    padding: .5rem 1rem;
  }

  @media (min-width: 800px) {
    flex: 1 0 30%;
    margin: 1rem;

    a {
      font-size: 1.1rem;
      padding: 1rem 3rem;
    }
  }
`

const TestimonialLogoContainer = styled.div`
  width: 5rem;
  height: 5rem;
  background: #fbbd08;
  border-radius: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 1rem;
  overflow: hidden;
`

const TestimonialLogo = styled.img`
max-width: 100%;
`


const TestimonialTitle = styled.div`
`

const TestimonialBody = styled.p`
  height: 200px;
`

const TestimonialAuthor = styled.div`
  color: #fbbd08;
  font-size: 0.8rem;
`

const TestimonialLocation = styled.div`
  font-size: 0.8rem;
  font-weight: bold;
  margin-top: 0.5rem;
`

const TestimonialQuote = styled.div`
  position: absolute;
  width: 3rem;
  font-size: 5rem;
  height: 3rem;
  text-align: center;
  line-height: 6rem;
  background-color: #18aa7a;
  color: #fbbd08;
  left: .5rem;
  top: -1rem;
`

const TestimonialCard = (props) => {
  return (
    <TestimonialCardContainer>
      <TestimonialQuote>"</TestimonialQuote>
      <TestimonialLogoContainer>
        <TestimonialLogo src={props.image} alt={props.title} />
      </TestimonialLogoContainer>
      <SectionPreHeader lower align="center">{props.title}</SectionPreHeader>
      <TestimonialBody>{props.body}</TestimonialBody>
      <TestimonialAuthor>{props.author}</TestimonialAuthor>
      <TestimonialLocation>{props.hotel}</TestimonialLocation>
    </TestimonialCardContainer>
  )
}


const TestimonialsList = (props) => {
  return (
    <TestimonialList>
      {props.testimonials.map((testimonial, i) => (
        <TestimonialCard
          key={i}
          {...testimonial}
        />
      ))}
    </TestimonialList>
  );
}
 
export default TestimonialsList;



// WEBPACK FOOTER //
// ./src/components/TestimonialsList.js